export default __webpack_public_path__ + "static/media/notdelivering.8d376e6c.svg";